import { ref } from 'vue'
import { functions, httpsCallable } from '@/firebase/config'

const error = ref(null)

const updateUserCredential = async (userCredential) => {
  error.value = null
  const updateCredential = httpsCallable(functions, 'updateCredential')

  updateCredential({ userCredential }).then(result => {
    console.log(result)
  }).catch((error) => {
    // Getting the Error details.
    const code = error.code
    const message = error.message
    const details = error.details
    error.value = code + message + details
    // ...
  })
}
// Call updateUser.js
const updateUser = () => {
  return { error, updateUserCredential }
}

export default updateUser
